import { UniIconButton } from '@/design-system/components/buttons';
import { BottomSheetHeader } from '@/design-system/components/headers';
import { TextCaption, TextTitle } from '@/design-system/components/typography';
import { keyGenerator } from '@/utils/keyGenerator';
import BottomSheet, { BottomSheetBackdrop, useBottomSheetDynamicSnapPoints } from '@gorhom/bottom-sheet';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { ScrollView, SxProp, View } from 'dripsy';
import { useCallback, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CardDetailStackParamList } from './type';

export interface TransactionInfoNativeProps {
  xmetadata: { [key: string]: any };
}

export const TransactionInfoNativeScreen: React.FC<TransactionInfoNativeProps> = ({ xmetadata }) => {
  const { t } = useTranslation('account-management');
  const layout = useContext(LayoutContext);
  const { width, height } = layout.dimensions;
  const { modal } = sxStyles;
  const navigation = useNavigation<NativeStackNavigationProp<CardDetailStackParamList>>();

  const renderBackdrop = useCallback(
    (props) => <BottomSheetBackdrop {...props} disappearsOnIndex={0} appearsOnIndex={1} pressBehavior={'none'} enableTouchThrough={true} />,
    []
  );
  const snapPoints = useMemo(() => ['50%', '50%'], []);
  const { animatedHandleHeight, animatedSnapPoints, animatedContentHeight, handleContentLayout } = useBottomSheetDynamicSnapPoints([
    'CONTENT_HEIGHT',
    'CONTENT_HEIGHT'
  ]);

  return (
    <View sx={{ width, height, backgroundColor: 'transparent', flex: 1 }}>
      <BottomSheet enablePanDownToClose index={1} snapPoints={snapPoints} backdropComponent={renderBackdrop}>
        <ScrollView sx={{ backgroundColor: '$backgroundPrimary' }} onLayout={handleContentLayout}>
          <View sx={modal}>
            <View>
              <View sx={{ paddingBottom: '$4' }}>
                <TextTitle semiBold sx={{ display: 'flex', justifyContent: 'center' }}>
                  {t('card-account-management::card-details.text--view-xmetadata')}
                </TextTitle>
                <View sx={{ position: 'absolute', right: 0, zIndex: 2 }}>
                  <UniIconButton icon="cross" onPress={() => navigation.goBack()}></UniIconButton>
                </View>
              </View>
              <View sx={{ flexDirection: 'column', gap: '$3' }}>
                {Object.keys(xmetadata).map((key) => (
                  <View key={keyGenerator(key + '-transaction')} sx={{ flexDirection: 'column', gap: '$1' }}>
                    <TextTitle semiBold>{key}:</TextTitle>
                    <TextCaption>{xmetadata[key]}</TextCaption>
                  </View>
                ))}
              </View>
            </View>
          </View>
        </ScrollView>
      </BottomSheet>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  modal: {
    width: '100%',
    padding: '$4'
  }
};
